import {useContext, useEffect} from 'react'
import {FetchModalHeader} from './FetchModalHeader'
import {FetchModalPageWrapper} from './FetchModalPageWrapper'
import {useQuery} from '@tanstack/react-query'
import {getOpenBookingById} from '../../../modules/apps/booking/list/core/_requests'
import {QUERIES, isNotEmpty} from '../../../../_metronic/helpers'
import {ListLoading} from '../../../../_component/ListLoading'
import {BookingContext} from '../Page'

const FetchModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const {id, setShow} = useContext(BookingContext)
  const enabledQuery: boolean = isNotEmpty(id)
  const {
    isInitialLoading: isLoading,
    data: booking,
    error,
  } = useQuery(
    [`${QUERIES.BOOKINGS_LIST}-booking-${id}`],
    () => {
      return getOpenBookingById(id)
    },
    {
      enabled: enabledQuery,
      onError: (err) => {
        setShow(false)
        console.error(err)
      },
    }
  )
  return (
    <>
      <div
        className='modal fade show d-block modal-xl'
        id='kt_modal_add_booking'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <FetchModalHeader booking={booking} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-10 my-2'>
              <FetchModalPageWrapper error={error} booking={booking} />
              {isLoading && <ListLoading />}
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {FetchModal}
